import useApi from "./useApi";

const useBankAccount = () => {
    const { getJson, postJson } = useApi();

    /**
     * Fetches the supported bank account types from the API.
     * @returns {Promise<string[]>}
     */
    const getSupportedBankTypes = async () => {
        const response = await getJson('/online/bankaccounttypes');
        return (response.overpaidbankaccount ?? []).map(item => item.type);
    }

    /**
     * Posts a new bank account to the API.
     * @param data
     * @returns {Promise<*>}
     */
    const postBankAccount = async (data) => {
        return await postJson('/online/bankaccount', data);
    }

    return {
        getSupportedBankTypes,
        postBankAccount
    }
}

export default useBankAccount;
